<script setup lang="ts">
import CoreLoader from "@/components/core/core-loader.vue";
import CoreIcon, { CoreIconProps } from '@core/core-icon.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { UserConnectNotification } from '@/store/api/interfaces';

interface Props {
	notification: UserConnectNotification
};

const props = defineProps<Props>();
const { t } = useI18n();


// todo: make utils
const capitalize = (str: string) => str ? str[0].toUpperCase() + str.slice(1) : '';

const message = computed(() => {
	const provider = props.notification?.provider || '';
	switch(props.notification.status) {
		case "success":
			return t('accountIndex.notification.success', {
				provider: capitalize(provider),
			});
		case "failed":
			const errorMessage = props.notification.code ? `errorCode.${props.notification.code}` : 'accountIndex.notification.failed';
			return t(errorMessage, {
				provider: capitalize(provider),
			});
		case "waiting":
			return t('accountIndex.notification.waiting', {
				provider: capitalize(provider),
			});
	}
});

const statusIcon = computed<CoreIconProps>(() => {
	if (props.notification.status === 'success') {
		return { name: "checkbox", viewBox: "0 0 12 8" };
	}

	return { name: "cross", viewBox: "0 0 18 18" };
});

</script>
<template>
	<div class="part-notification-message">
		<core-loader
			v-if="notification.status === 'waiting'"
			class="part-notification-message__loader"
		/>
		<core-icon
			v-else
			v-bind="statusIcon"
			class="part-notification-message__icon"
		/>

		<div class="part-notification-message__message">
			{{ message }}
		</div>

		<slot />
	</div>
</template>

<style lang="scss">
.part-notification-message {
	text-align: center;
	display: flex;
	flex-direction: column;
	&__message {
		opacity: 0.6;
		margin-top: 2rem;
	}

	&__loader {
		margin-bottom: 0;
		--loader-size: 6rem;
		--loader-width: 4px;
		--loader-color: var(--color-active);
	}

	&__icon {
		width: 6rem;
		margin: auto;
		fill: var(--color-active);

		&.icon-cross {
			fill: var(--color-red);
		}
	}
}
</style>
